import PageBody from './ui/PageBody';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { articlePath } from '../utils/articlePath';
import IconButton from './ui/IconButton';
import ArticleLink, { externalUrlOf } from './ArticleLink';
import { mediaUrl } from '../api';

function ArticleList({
  articles = [],
  onToggleVisibility,
  showTags = false,
}) {
  const { t } = useTranslation();

  console.log(
    articles.map((article) => ({
      id: article.article_id,
      title: article.title,
      has_history: article.has_history,
    }))
  );

  return (
    <PageBody className="articles-list">
      {articles.map((article) => (
        <article
          key={article.article_id}
          className="article-list-item"
        >
          <div className="article-list-content">
            <ArticleLink
              article={article}
              className="article-list-title"
            >
              {article.icon ? (
                <img
                  className="article-list-title-image"
                  src={mediaUrl(article.icon)}
                  alt=""
                />
              ) : (

                <span
                  className="article-list-document-icon"
                  aria-hidden="true"
                >
                  <i className="fa-regular fa-image" />
                </span>

              )}

              <span>{article.title}</span>
              {externalUrlOf(article) && (
                <i className="fa-solid fa-arrow-up-right-from-square article-list-external" aria-hidden="true" />
              )}
            </ArticleLink>

            {showTags &&
              article.tags?.length > 0 && (
                <div className="tags-list">
                  {article.tags.map((tag) => (
                    <Link
                      key={tag}
                      to={`/tag/${encodeURIComponent(tag)}`}
                      className="tag tag-small"
                    >
                      <span className="tag-symbol">
                        #
                      </span>

                      <span className="tag-text">
                        {tag}
                      </span>
                    </Link>
                  ))}
                </div>
              )}
          </div>

          <div className="article-list-actions">
            <IconButton
              className="article-visibility-button"
              icon={
                article.is_news
                  ? 'fa-solid fa-bullhorn'
                  : 'fa-regular fa-file-lines'
              }
              label={
                article.is_news
                  ? t('articlesPage.newsArticle')
                  : t('articlesPage.regularArticle')
              }
            />

            {article.canChangeVisibility &&
              externalUrlOf(article) && (
                <IconButton
                  className="article-visibility-button"
                  icon="fa-solid fa-pen-to-square"
                  label={t('articleLink.editLink')}
                  to={articlePath(article)}
                />
              )}

            {article.canChangeVisibility &&
              onToggleVisibility && (
                <IconButton
                  className="article-visibility-button"
                  icon={
                    article.is_hidden
                      ? 'fa-solid fa-eye-slash'
                      : 'fa-solid fa-eye'
                  }
                  label={
                    article.is_hidden
                      ? t('articlesPage.showArticle')
                      : t('articlesPage.hideArticle')
                  }
                  onClick={() => onToggleVisibility(article)}
                />
              )}


            {article.canChangeVisibility && (
              <IconButton
                className={`article-visibility-button${article.has_history ? '' : ' article-history-disabled'}`}
                icon="fa-solid fa-clock-rotate-left"
                label={
                  article.has_history
                    ? t('articlesPage.showFromArchive')
                    : t('articlesPage.noHistory')
                }
                title={
                  article.has_history
                    ? t('articlesPage.showFromArchive')
                    : t('articlesPage.noHistory')
                }
                to={
                  article.has_history
                    ? `/archive/${article.article_id}/history`
                    : undefined
                }
                disabled={!article.has_history}
              />
            )}


          </div>
        </article>
      ))}
    </PageBody>
  );
}

export default ArticleList;